module.exports = __webpack_public_path__ + "img/scop5.ba7837e3.jpg";